import React from "react";
import { useTranslation } from "react-i18next";

import ChatBotBannerImg from '../../../../assets/chatbot/Ativo_4-8.png'
import './chatbotBanner.scss'

const ChatBotBanner = () => {
    const { t } = useTranslation()

    return (
        <div className="container-chatbot-banner">
            <div className='img-chatbot-banner'>
                <img src={ChatBotBannerImg} alt="" />
            </div>
            <div className='texts-chatbot-banner'>
                <h1>{t("chat.title")}</h1>
                <p>{t("chat.section_text")}</p>
                <a href="/form">
                    <button id="btn-chatbot-banner">
                        {t("buttons.demo_btn_alternative_text_1")}
                    </button>
                </a>
            </div>
        </div>
    )
}

export default ChatBotBanner